<template>
  <div class="q-d-grid q-gap-2 q-col-12 q-mt-2 q-mx-auto more-results__container">
    <a v-if="hasAnyResults" class="q-btn q-btn-danger q-btn more-results__link" tabindex="-1" role="button"
       @click.prevent="urlStore.goToSerpPage(`${SmartSearchConfig.appConfiguration.redirectionUrl}?q=${getSearchQuery}`, SmartSearchConfig.appConfiguration.redirectionUrl )">
      {{ SmartSearchTranslations.autocomplete.seeMore }}
      <span v-if="loading"
            class="q-spinner-border q-spinner-border-sm q-ms-2" role="status" aria-hidden="true"></span>
      <span v-else v-show="popupStore.getTotalProducts"> ({{ popupStore.getTotalProducts }})</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {storeToRefs} from "pinia"
import {inject} from 'vue';
import {SmartSearchTranslationsInterface} from "@/core/types";

const SmartSearchConfig = inject('SmartSearchConfig').value
const urlStore = useUrlStore()
const popupStore = usePopupStore()


const searchQueryStore = useSearchQueryStore()
const {getSearchQuery} = storeToRefs(searchQueryStore)
const {hasAnyResults, loading} = storeToRefs(popupStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


</script>

<style scoped>

@-webkit-keyframes q-spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}

@keyframes q-spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.q-spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite q-spinner-border;
  animation: 0.75s linear infinite q-spinner-border;
}

.q-spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@-webkit-keyframes q-spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}

@keyframes q-spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.q-spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  -webkit-animation: 0.75s linear infinite spinner-grow;
  animation: 0.75s linear infinite spinner-grow;
}

.q-spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .q-spinner-border,
  .q-spinner-grow {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
  }
}
</style>
